import { AbstractFormatAlert } from "./AbstractFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export abstract class AbstractFormatPropertyAlert extends AbstractFormatAlert {
  constructor(propertyKind: string, isError: boolean) {
    super(isError);
    this._target = propertyKind;
  }

  protected readonly _target: string;
  
  get target(): string {
    return this._target;
  }

  get kind(): string {
    return "フォーマット属性警告";
  }
  // フォーマット属性の警告なので、オブジェクトは見ない。
  get detectedObject(): IFormatObjectEditable {
    return null;
  }
}
